var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { OutOfRootError } from './Errors';
import { areURLDescriptorsEqual, createURLDescriptor } from './URLTools';
import { SegmentType } from './Segments';
import { Deferred } from './Deferred';
import { SimpleSubscription, createOrPassthroughObserver } from './Observable';
export function createCurrentRouteObservable(options) {
  return new CurrentRouteObservable(options.history, options.router);
}
/**
 * An observable that tracks the current location of a History object,
 * passing it through a router each time it changes, and emitting the
 * lastest route from the latest router.
 */

var CurrentRouteObservable =
/** @class */
function () {
  function CurrentRouteObservable(history, router) {
    var _this = this;

    this.handleUnsubscribe = function (observer) {
      var index = _this.observers.indexOf(observer);

      if (index !== -1) {
        _this.observers.splice(index, 1);
      }
    }; // Allows for either the location or route or both to be changed at once.


    this.update = function (route) {
      var url = _this.lastURL;
      var nextRoute = route || _this.lastRoute;
      var lastSegment = route && route.lastSegment;

      if (lastSegment && lastSegment.type === SegmentType.Redirect && lastSegment.to) {
        // No need to notify any listeners of a ready redirect,
        // as we can take the appropriate action ourselves
        _this.history.replace(lastSegment.to);

        return;
      }

      _this.lastRoute = __assign({}, nextRoute, {
        url: url
      });

      if (_this.waitUntilSteadyDeferred && _this.lastRoute.isSteady) {
        _this.waitUntilSteadyDeferred.resolve(_this.lastRoute);

        delete _this.waitUntilSteadyDeferred;
      }

      for (var i = 0; i < _this.observers.length; i++) {
        _this.observers[i].next(_this.lastRoute);
      }
    };

    this.observers = [];
    this.router = router;
    this.history = history;
    this.lastURL = createURLDescriptor(this.history.location);
    this.unlisten = this.history.listen(function (location) {
      return _this.handleURLChange(createURLDescriptor(location));
    });
    this.refresh();
  }

  CurrentRouteObservable.prototype.dispose = function () {
    this.observers.length = 0;
    this.unlisten();
    delete this.unlisten;
    delete this.history;

    if (this.observableSubscription) {
      this.observableSubscription.unsubscribe();
    }

    delete this.observableSubscription;
    delete this.router;
    delete this.waitUntilSteadyDeferred;
    delete this.lastRoute;
  };

  CurrentRouteObservable.prototype.refresh = function () {
    this.handleURLChange(createURLDescriptor(this.history.location), true);
  };

  CurrentRouteObservable.prototype.setRouter = function (router) {
    this.router = router;
    this.refresh();
  };
  /**
   * Get the latest route
   */


  CurrentRouteObservable.prototype.getValue = function () {
    return this.lastRoute;
  };
  /**
   * Returns a promise that resolves once the route is steady.
   * This is useful for implementing static rendering, or for waiting until
   * content is loaded before making the first render.
   */


  CurrentRouteObservable.prototype.getSteadyRoute = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        if (this.error) {
          return [2
          /*return*/
          , Promise.reject(this.error)];
        } else if (this.lastRoute && this.lastRoute.isSteady) {
          return [2
          /*return*/
          , Promise.resolve(this.lastRoute)];
        } else if (!this.waitUntilSteadyDeferred) {
          this.waitUntilSteadyDeferred = new Deferred();
        }

        return [2
        /*return*/
        , this.waitUntilSteadyDeferred.promise];
      });
    });
  };
  /**
   * If you're using code splitting, you'll need to subscribe to changes to
   * Route, as the route may change as new code chunks are received.
   */


  CurrentRouteObservable.prototype.subscribe = function (onNextOrObserver, onError, onComplete) {
    var observer = createOrPassthroughObserver(onNextOrObserver, onError, onComplete);
    this.observers.push(observer);
    return new SimpleSubscription(this.handleUnsubscribe, observer);
  };

  CurrentRouteObservable.prototype.handleURLChange = function (url, force) {
    // Bail without change is the URL hasn't changed
    if (!force && this.lastReceivedURL && areURLDescriptorsEqual(this.lastReceivedURL, url)) {
      for (var i = 0; i < this.observers.length; i++) {
        this.observers[i].next(this.lastRoute);
      }

      return;
    }

    this.lastReceivedURL = url; // Ensure the pathname always has a trailing `/`, so that we don't
    // have multiple URLs referring to the same page.

    if (url.pathname.substr(-1) !== '/') {
      url = __assign({}, url, {
        pathname: url.pathname + '/'
      });
      this.history.replace(url);
      return;
    }

    var lastURL = this.lastURL;
    this.lastURL = url;
    var pathHasChanged, searchHasChanged;

    if (url && lastURL) {
      pathHasChanged = url.pathname !== lastURL.pathname;
      searchHasChanged = url.search !== lastURL.search;
    } // The router only looks at path and search, so if they haven't
    // changed, there's no point recreating the observable.


    if (!force && !(pathHasChanged || searchHasChanged) && !this.lastRoute.error) {
      this.update();
      return;
    }

    if (this.observableSubscription) {
      this.observableSubscription.unsubscribe();
    }

    var observable = this.router.createObservable(url, {
      withContent: true
    });

    if (observable) {
      this.observableSubscription = observable.subscribe(this.update);
    } else if (!lastURL) {
      throw new OutOfRootError(url);
    }
  };

  return CurrentRouteObservable;
}();

export { CurrentRouteObservable };